// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

apiSlice.enhanceEndpoints({
  addTagTypes: ["MediaImages"],
});

export const mediaGalleryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMediaImages: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/car-image/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: ["MediaImages"],
    }),
    uploadMediaImage: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/car-image",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MediaImages"],
    }),

    deleteMediaImage: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/admin/car-image/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MediaImages"],
    }),
  }),
});

export const {
  useGetMediaImagesQuery,
  useUploadMediaImageMutation,
  useDeleteMediaImageMutation,
} = mediaGalleryApiSlice;
